import { OwcButton } from "@one/react";
import React from "react";
import NoConnectionIcon from "../icons/NoConnectionIcon";

const NoConnectionScreen = ({
  text = "We are having difficulty connecting to the server. Check your connection or try again later.",
  title = "No connection",
  onCallback
}) => {
  return (
    <div data-testid="main-page-not-authenticated-with-error-conection">
      <NoConnectionIcon />
      <h2>{title}</h2>
      <h5>{text}</h5>
      <OwcButton data-testid="main-page-action-button-error-conection" variant="error" onClick={onCallback}>
        Retry
      </OwcButton>
    </div>
  );
};

export default NoConnectionScreen;
